import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    selector: 'installation-comments',
    templateUrl: './installation-comments.component.html',
    standalone: false
})
export class InstallationCommentsPluginComponent {
  public comments: any[];
  public config: any;
  public editRoute = ['installation', 'comments', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.comments = this.config.Comments;
  }
}
PluginComponent.plugins['installationcomments'] = InstallationCommentsPluginComponent;
